<template>
  <div style="padding:15px">
    <vxe-toolbar id="toolbarId_sy91" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <div class="function-box">
          <el-button v-if="getLimit('accountDetail_sumDownload_search_button')" @click="funcFilter">
            查询
          </el-button>
          <el-button v-if="getLimit('accountDetail_sumDownload_export_button')" @click="funcExport">
            导出
          </el-button>
          <div class="">
            <el-button v-if="getLimit('accountDetail_sumDownload_applyAccount_button')" type="primary" align="right" @click="applyAccount">
              申请汇总对账单
            </el-button>
            <el-date-picker v-model="form.month" type="month" align="right" value-format="yyyyMM" placeholder="请选择年月" :picker-options="optionsPickerYearMonth" />
          </div>
        </div>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      row-id="id"
      height="500"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="receiptNo" title="电子回单编号" min-width="150" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.receiptNo" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column field="month" title="所属月份" min-width="100" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.month" placeholder="请输入" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="status" title="状态" :formatter="formatterStatus" min-width="100" sortable />
        <template v-slot:header>
          <el-select v-model="listQuery.status" placeholder="--请选择--" clearable>
            <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="gmtCreated" title="申请时间" min-width="200" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" min-width="200">
        <template slot-scope="scope">
          <el-tooltip v-if="getLimit('accountDetail_sumDownload_donwload_button') && scope.row.status =='02'" class="item" effect="dark" content="下载" placement="top">
            <vxe-button type="text" @click="showElectronicReceipt(scope.row)">
              <i class="el-icon-download" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip v-if="getLimit('accountDetail_sumDownload_refresh_button') && scope.row.status =='01'" class="item" effect="dark" content="刷新" placement="top">
            <vxe-button type="text" @click="statusQuery(scope.row)">
              <i class="el-icon-refresh" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager :loading="loading" :current-page.sync="listQuery.pageNum" :page-size.sync="listQuery.pageSize" :total="listQuery.total" :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']" @page-change="handlePageChange" />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import {
  mybankElectronicReceipt,
  mybankElectronicReceiptInfo,
  electronicReceiptQuery,
  batchApply,
} from "@/api/InternetBanking";
export default {
  name: "PartyGroupList",
  components: {},
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      optionsPickerYearMonth: this.banTime(),
      // 载重状态
      statusOption: [
        { label: "处理中", value: "01" },
        { label: "成功", value: "02" },
        { label: "失败", value: "03" },
      ],
           exportObj:{
        exportUrl:"/ntocc-tms-api/mybankElectronicReceipt/exportStatementAccount",//导出接口
        name:'下载汇总对账单'
        },
      listQuery: {
        gmtCreatedRange:'',
        branchCode: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        type: 1,
      },
      form: {
        type: 1,
        month: "",
        branchCode: "",
      },
       
    };
  },
  created() {
    this.findList();
  },
  methods: {
    banTime() {
      return {
        disabledDate(time) {
          const date = new Date();
          const year = date.getFullYear();
          let month = date.getMonth() + 1;
          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          const currentdate = year.toString() + month.toString();
          const timeyear = time.getFullYear();
          let timemonth = time.getMonth() + 1;
          if (timemonth >= 1 && timemonth <= 9) {
            timemonth = "0" + timemonth;
          }
          const timedate = timeyear.toString() + timemonth.toString();
          return currentdate <= timedate;
        },
      };
    },
    findList() {
      this.listQuery.branchCode = this.$route.query.code || "";
      this.form.branchCode = this.$route.query.code || "";
      this.loading = true;
      return new Promise((resolve) => {
        mybankElectronicReceipt(this.listQuery, "get").then((response) => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    //更新申请结果
    statusQuery(row) {
      const rLoading = this.openLoading();
      electronicReceiptQuery(row.receiptNo).then((response) => {
        rLoading.close();
        let type = response.status === 0 ? "success" : "error";
        this.findList();
        this.$message({
          message: response.msg,
          type: type,
        });
      });
    },
    showElectronicReceipt(row) {
      mybankElectronicReceiptInfo(row.receiptNo)
        .then((res) => {
          let url = res.data.pdfDownloadUrl;
          window.open(url, "_blank");
        })
        .catch((res) => {});
    },
    applyAccount() {
      batchApply(this.form)
        .then((res) => {
          if (res.status == 0) {
            this.$message({ message: res.msg, type: "success" });
            this.findList();
          }
        })
        .catch((res) => {});
    },
    // 翻译载重状态
    formatterStatus({ cellValue }) {
      const item = this.statusOption.find((item) => item.value === cellValue);
      return item ? item.label : "";
    },
  },
};
</script>
<style scoped>
.function-box {
  display: flex;
  justify-content: space-between;
}
</style>
